import api from './api';

const eventLogService = {
    /**
     * Get event logs
     * @param {string} module - The module name (e.g., 'Practice', 'Provider', 'Caregiver')
     * @param {string|number} targetUserId - The ID of the target user/entity (optional)
     * @param {object} params - Query parameters (page, limit, practiceId, patientId)
     * @returns {Promise<object>} - The response data (logs, pagination)
     */
    getLogs: async (module, targetUserId = null, params = {}) => {
        try {
            let url = `/event-logs`;

            const queryParams = new URLSearchParams();
            if (module) queryParams.append('moduleId', module);
            if (targetUserId) queryParams.append('targetUserId', targetUserId);

            Object.keys(params).forEach(key => {
                if (params[key] !== undefined && params[key] !== null) {
                    queryParams.append(key, params[key]);
                }
            });

            const response = await api.get(`${url}?${queryParams.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching event logs:', error);
            throw error;
        }
    }
};

export default eventLogService;
